import { Injectable } from '@angular/core';
import { TreeTableComponent } from '@farris/ui-treetable';
@Injectable()
export class FarrisTreetableFormatService {
    constructor() {
    }
    setFormat(treeTable: TreeTableComponent) {
        const columns = treeTable.columns;
        columns.forEach((column: any) => {
            const dataType = column.dataType;
            if (!column.formatter) {
                if (dataType === 'date') {
                    column.formatter = {
                        type: 'datetime',
                        options: {
                            format: column.format
                        }
                    };
                } else if (dataType === 'number') {
                    column.formatter = {
                        type: 'number',
                        options: {
                            prefix: column.prefix ? column.prefix : '',
                            suffix: column.suffix ? column.suffix : '',
                            precision: column.precision,
                            thousand: ',',
                            stripZeros: false,
                        }
                    };
                } else if (dataType === 'enum') {
                    column.formatter = {
                        type: 'enum',
                        options: {
                            data: column.enumData,
                            valueField: 'value',
                            textField: 'name'
                        }
                    };
                } else if (dataType === 'boolean') {
                    column.formatter = {
                        type: 'enum',
                        options: {
                            data: [{ name: 'æ¯', value: true }, { name: 'å¦', value: false }],
                            valueField: 'value',
                            textField: 'name'
                        }
                    };
                }
            }
        });
    }

}
